import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';

type BatteryItem = {
  icon: string;
  color: string;
};

const BATTERY_ITEMS = [
  { icon: 'battery_full_alt', color: 'tw-text-green-500', minLevel: 76 },
  { icon: 'battery_horiz_075', color: 'tw-text-green-500', minLevel: 51 },
  { icon: 'battery_horiz_050', color: 'tw-text-green-500', minLevel: 26 },
  { icon: 'battery_low', color: 'tw-text-yellow-500', minLevel: 15 },
  { icon: 'battery_very_low', color: 'tw-text-red-500', minLevel: 0 },
];

@Component({
  selector: 'app-battery-icon',
  standalone: true,
  imports: [CommonModule, MatCardModule, RouterModule],
  templateUrl: './battery-icon.component.html',
  styleUrl: './battery-icon.component.scss',
})
export class BatteryIconComponent {
  /** バッテリー残量 */
  @Input() batteryPercentage: number | null = null;

  /** アイコンサイズ変更のカスタムクラス */
  @Input() customClass: string = '';

  get batteryStatus(): BatteryItem {
    if (this.batteryPercentage == null) {
      return { icon: '', color: '' };
    }

    const status = BATTERY_ITEMS.map((item) => ({
      icon: item.icon,
      color: item.color,
      isMatch: this.batteryPercentage! >= item.minLevel,
    })).find((item) => item.isMatch);

    return status
      ? { icon: status.icon, color: status.color }
      : { icon: '', color: '' };
  }
}
